"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactAI = void 0;

var _react = _interopRequireDefault(require("react"));

var _applicationinsightsJs = require("applicationinsights-js");

var _appinsightsUsage = _interopRequireDefault(require("appinsights-usage"));

var _away = _interopRequireDefault(require("away"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ReactAI = {
  init: function init(appInsightsOptions, history) {
    _applicationinsightsJs.AppInsights.downloadAndSetup(appInsightsOptions);

    _appinsightsUsage.default.init(appInsightsOptions);

    if (history) {
      history.listen(function (_location, _action) {
        _applicationinsightsJs.AppInsights.trackPageView();
      });
    }

    this.setAppContext({
      urlReferrer: document.referrer
    });
  },
  ai: function ai() {
    return _applicationinsightsJs.AppInsights;
  },
  setAppContext: function setAppContext(properties) {
    _applicationinsightsJs.AppInsights.queue = _applicationinsightsJs.AppInsights.queue || [];

    _applicationinsightsJs.AppInsights.queue.push(function () {
      _applicationinsightsJs.AppInsights.context.addTelemetryInitializer(function (envelope) {
        var telemetryItem = envelope.data.baseData; // To set custom properties:

        telemetryItem.properties = telemetryItem.properties || {};

        for (var key in properties) {
          telemetryItem.properties[key] = properties[key];
        }
      });
    });
  },
  withTracking: function withTracking(WrappedComponent, componentName) {
    // Note: This check can be better if Lodash is added as a dependency.
    if (componentName === undefined || componentName === null || typeof componentName !== 'string') {
      componentName = WrappedComponent.prototype.constructor.name;
    }

    return (
      /*#__PURE__*/
      function (_React$Component) {
        _inherits(_class, _React$Component);

        function _class() {
          _classCallCheck(this, _class);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
        }

        _createClass(_class, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.componentDidMountTimestamp = Date.now();
            this.idleTimeInMs = 0;
            var timer = (0, _away.default)(30000);
            var self = this;
            timer.on('idle', function () {
              self.startIdleTimer = Date.now();
            });
            timer.on('active', function () {
              self.idleTimeInMs += Date.now() - self.startIdleTimer;
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            if (!this.componentDidMountTimestamp) {
              throw 'ComponentDidMountTimestamp was not initialized.';
            }

            _applicationinsightsJs.AppInsights.trackMetric('React Component Engaged Time (seconds)', (Date.now() - this.componentDidMountTimestamp - (this.idleTimeInMs ? this.idleTimeInMs : 0)) / 1000, 1, null, null, {
              'Component Name': componentName
            });
          }
        }, {
          key: "render",
          value: function render() {
            return _react.default.createElement(WrappedComponent, this.props);
          }
        }]);

        return _class;
      }(_react.default.Component)
    );
  }
};
exports.ReactAI = ReactAI;